import "bootstrap/dist/css/bootstrap.min.css";
import { Role } from "../../../Model/Setting/Role";
import AddUpdateForm from "../../../Components/AddUpdateForm";
import { Breadcrumb, Button } from "react-bootstrap";
import FieldDescription from "../../../Components/FieldDescription";
import { useState } from "react";
import { useParams } from "react-router-dom";
interface AddUpdateProps {
  title?: any;
  listRoute?: any;
  isNotUpdate?: any;
  onChangeModalStatus?: (status: boolean) => void;
}

const AddUpdate: React.FC<AddUpdateProps> = ({
  title,
  listRoute,
  isNotUpdate,
  onChangeModalStatus,
}) => {
  const [isShows, setIsShows] = useState<boolean>(false);
  const { id }: any = useParams();
  const formFields = [
    {
      id: "inputName",
      label: "Name*",
      type: "text",
      col: 6,
      name: "name",
      placeholder: "Enter Name",
      validate: [
        {
          rule: (value: any) => !!value,
          message: "Name is required",
        },
        {
          rule: (value: string) => /^[a-zA-Z_]+$/.test(value),
          message: "Name should contain only letters and '_' ",
        },
      ],
      description: "Enter the name of User Roles.",
    },
    {
      id: "inputSlug",
      label: "Slug*",
      type: "text",
      col: 6,
      name: "slug",
      placeholder: "Enter Slug",
      disabled: true,
      validate: [
        {
          rule: (value: any) => !!value,
          message: "Slug is required",
        },
      ],
      description:
        "Assign a slug to the sub-user for a clean and readable URL.<br/> Use underscores to separate words.<br/>Keep it short, descriptive, and unique.<br/>(Example: If the user's name is John Doe, the slug could be JOHN_DOE.)",
    },
  ];
  const handleHelpButtonClick = () => {
    setIsShows(!isShows);
    const formBottom = document.getElementById("form-bottom");
    if (formBottom) {
      formBottom.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };
  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        <Breadcrumb.Item href="/roles">Roles</Breadcrumb.Item>
        <Breadcrumb.Item active className="fw-bold">
          {!id ? "Add Roles" : "Edit Roles"}
        </Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <span style={{ float: "inline-end" }}>
          <Button variant="outline-secondary" onClick={handleHelpButtonClick}>
            Need Help?
          </Button>
        </span>
        <AddUpdateForm
          formFields={formFields}
          model={Role}
          title={title}
          listRoute={listRoute}
          autoUpdateField={true}
          isNotUpdate={isNotUpdate}
          onChangeModalStatus={onChangeModalStatus}
        />
      </div>
      <div id="form-bottom">
        <FieldDescription
          title={title}
          formFields={formFields}
          isShows={isShows}
        />
      </div>
    </>
  );
};

export default AddUpdate;
